module.exports = __webpack_public_path__ + "images/emoji/station.56f562ec178dd98cdad6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/station.png
// module id = wgJK
// module chunks = 24